module.exports = __webpack_public_path__ + "img/webfont.871ccc59.svg";